// import { colors } from '@mui/material';
const palette = {
    common: {
        black: '#000',
        white: '#fff',
    },
    contract: {
        main: '#007bad',
        secondary: '#e26c3a',
    },
    tertiary: {
        main: '#fcbe00',
    },
    // custom colors from design
    lightBlue: {
        300: '#1e98c9', // we may have others so should set 200 for lighter or 400 for darker
        800: '#037bad',
    },
    greyCustom: {
        200: '#f0f0f0',
        300: '#edf0f5',
        600: '#7f7f7f',
        800: '#40484f',
        A200: '#ebebeb',
    },
    indigoCustom: {
        700: '#004789',
        900: '#142261',
    },
    // used by admin
    backgroundSecondary: '#f7f8fa',
    backgroundTertiary: 'rgba(0, 0, 0, 0.5)',
    // // // // //
    // used by Portal
    backgroundDark: '#0a1d4a',
    // lighten backgroundDark by 5% => Tool: https://www.cssfontstack.com/oldsites/hexcolortool/
    backgroundDarkHover: '#172A57',
    backgroundDarkSelected: '#0a1d4a', // for now same as backgroundDark
    backgroundLightHover: 'rgba(0, 123, 173, 0.04)',
    // // // // //
    dividerSecondary: '#91bfec',
};
export default palette;
//# sourceMappingURL=palette.js.map